/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_auth_sign_up_failed = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign up failed`)
};

const es_auth_sign_up_failed = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al registrarse`)
};

const de_auth_sign_up_failed = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrierung fehlgeschlagen`)
};

const nl_auth_sign_up_failed = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registratie mislukt`)
};

const fr_auth_sign_up_failed = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l’inscription`)
};

const it_auth_sign_up_failed = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrazione fallita`)
};

const pt_br2_auth_sign_up_failed = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha no cadastro`)
};

const pt_auth_sign_up_failed = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha no registo`)
};

const ja_auth_sign_up_failed = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登録に失敗しました`)
};

const zh_auth_sign_up_failed = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注册失败`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const auth_sign_up_failed = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.auth_sign_up_failed(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("auth_sign_up_failed", locale)
	if (locale === "en") return en_auth_sign_up_failed(inputs)
	if (locale === "es") return es_auth_sign_up_failed(inputs)
	if (locale === "de") return de_auth_sign_up_failed(inputs)
	if (locale === "nl") return nl_auth_sign_up_failed(inputs)
	if (locale === "fr") return fr_auth_sign_up_failed(inputs)
	if (locale === "it") return it_auth_sign_up_failed(inputs)
	if (locale === "pt-BR") return pt_br2_auth_sign_up_failed(inputs)
	if (locale === "pt") return pt_auth_sign_up_failed(inputs)
	if (locale === "ja") return ja_auth_sign_up_failed(inputs)
	return zh_auth_sign_up_failed(inputs)
};